import { apiSlice } from '../../api/apiSlice';
import { EMPLOYEE_SERVICENOW_APPROVALS } from '../../constants';

// Types for ServiceNow approval data
export interface ServiceNowApproval {
    'sysapproval.sys_id': string;
    sysapproval: string;
    'sysapproval.sys_created_on': string;
    'sysapproval.opened_by.name': string;
    'sysapproval.u_requested_for'?: string;
}

export interface ServiceNowApprovalResponse {
    result: ServiceNowApproval[];
}

export interface ServiceNowApiResponse {
    statusCode: number;
    message: string;
    data: ServiceNowApprovalResponse;
    status: boolean;
}

// ServiceNow API endpoints using RTK Query
export const serviceNowApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder:any) => ({
        getEmployeeServiceNowApprovals: builder.query({
            query: (employeeNumber: string) => ({
                url: `${EMPLOYEE_SERVICENOW_APPROVALS}?employeeNumber=${employeeNumber}`,
                method: 'GET',
            }),
            providesTags: ['ServiceNowApprovals'],
        }) as any,
    }),
}) as any;

export const { useGetEmployeeServiceNowApprovalsQuery } = serviceNowApiSlice;
